
//=======> ON VIEW MEDIA BRIGHTNESS
// Place "observe-fact observe-margin" class directly on fact div
const observeProductFactsArray = document.querySelectorAll('.observe-fact');

const callbackProductFacts = function(entries) {
  entries.forEach((entry) => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.classList.remove('observe-move-fact');
    } else {
      target.classList.add('observe-move-fact');
    }
  });
};

const observeProductFactsFilter = new IntersectionObserver(callbackProductFacts, {
  threshold: 1,
});

observeProductFactsArray.forEach(observation => {
  observeProductFactsFilter.observe(observation);
});




// custom intersectionObserver added to identify text with .observe-this and changed by removing .unobserve-this
// the third class name is the animation desired, like fade-this.  in CSS the style is saved as .unobserve-this.fade-this
// once .unobserve-this is removed, the style no longer affects its element.
// if there is a second item that you want to fade in with a delay, add .observe-second, ...third, ...fourth
// css style located in 31ko-base.css file

const observeThis = document.querySelectorAll('.observe-this');

const callbackFade = function(entries) {
  entries.forEach((entry) => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.classList.remove('unobserve-this');
    } else {
      target.classList.add('unobserve-this');
    }
  });
};

const observeFade = new IntersectionObserver(callbackFade, {
  threshold: .33,
});

observeThis.forEach(observation => {
  observeFade.observe(observation);
});

//=======> ON VIEW PLAY VIDEO
// Attach to video to play when in view
// Place "observe-video" class directly on video element
const observeVideoArray = document.querySelectorAll('.observe-video');

const callbackPlay = function(entries) {
  entries.forEach((entry) => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.play();
    } else {
      target.pause();
    }
  });
};

const observePlay = new IntersectionObserver(callbackPlay, {
  threshold: .33,
});

observeVideoArray.forEach(observation => {
  observePlay.observe(observation);
});


//=======> ON VIEW MEDIA BRIGHTNESS
// Place "observe-brightness observe-darken" class directly on video element
const observeBrightnessArray = document.querySelectorAll('.observe-brightness');

const callbackBrightness = function(entries) {
  entries.forEach((entry) => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.classList.remove('observe-darken');
    } else {
      target.classList.add('observe-darken');
    }
  });
};

const observeBrightnessFilter = new IntersectionObserver(callbackBrightness, {
  threshold: .33,
});

observeBrightnessArray.forEach(observation => {
  observeBrightnessFilter.observe(observation);
});